import { Dtos, SuretyAccountUnderwritingStatus, SuretyType } from "@inrev/common";
import { CARRIER_ROW_NAMES } from "@portal/components/features/bonding-line/carrierDisplay";
import { BondingLineState } from "./state/reducer";

const inrevRaw = (state: BondingLineState) => ({
	rate: state.inrev.rate,
	singleLimit: state.inrev.singleLimit,
	aggregateLimit: state.inrev.aggregateLimit,
	isPublished: state.inrev.isPublished,
});

const carrierRaw = (state: BondingLineState, carrierName: string) => {
	const draft = state.carriers[carrierName];
	return {
		suretyType: SuretyType.contract,
		carrierName,
		bondingLine: {
			rate: draft.rate,
			singleLimit: draft.singleLimit,
			aggregateLimit: draft.aggregateLimit,
		},
	};
};

export const buildApprovePayload = (
	state: BondingLineState,
): Dtos.Admin.SuretyAccount.Update.Underwriting.Status.Request | null => {
	const result = Dtos.Admin.SuretyAccount.Update.Underwriting.Status.Request.schema.safeParse({
		suretyType: SuretyType.contract,
		status: SuretyAccountUnderwritingStatus.approved,
		bondingLine: inrevRaw(state),
		carrierBondingLines: CARRIER_ROW_NAMES.map((carrierName) => carrierRaw(state, carrierName)),
	});
	return result.success ? result.data : null;
};

export const buildBondingLinesPayload = (
	state: BondingLineState,
): Dtos.Admin.SuretyAccount.Update.BondingLines.Request | null => {
	const result = Dtos.Admin.SuretyAccount.Update.BondingLines.Request.schema.safeParse({
		suretyType: SuretyType.contract,
		bondingLine: inrevRaw(state),
		carrierBondingLines: CARRIER_ROW_NAMES.map((carrierName) => carrierRaw(state, carrierName)),
	});
	return result.success ? result.data : null;
};

/**
 * Publish/unpublish toggles visibility only — it must persist the last-saved (baseline)
 * rate/limits, never the live draft, so an in-progress edit can't be committed by a
 * visibility toggle that skips the Save confirmation.
 */
export const buildPublishPayload = (
	state: BondingLineState,
	isPublished: boolean,
): Dtos.Admin.SuretyAccount.Update.BondingLine.Request | null => {
	const committed = state.baseline.inrev;
	const result = Dtos.Admin.SuretyAccount.Update.BondingLine.Request.schema.safeParse({
		suretyType: SuretyType.contract,
		bondingLine: {
			rate: committed.rate,
			singleLimit: committed.singleLimit,
			aggregateLimit: committed.aggregateLimit,
			isPublished,
		},
	});
	return result.success ? result.data : null;
};
